import React from 'react';
import axios from 'axios';
import { user_token } from '../../../services/Auth';

var token = localStorage.getItem(user_token);

export default class Receita extends React.Component {
    
    //PATCH LOGIC
    constructor() {
        super();
        this.state = {            
            prescription: "",
            status: "Realizada",

        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleSubmit = evt => {
        evt.preventDefault();

        const receita = {        
            prescription: this.state.prescription,
            status: this.state.status,    
        };

        //ID está setada -> Necessário Correção
        axios.patch(`http://api-convida.herokuapp.com/exam`, receita, {headers: {'x-access-token': token}} )
            .then(res => {
                console.log(res);
                console.log(res.data);
            })

    }

    render() {
        return (
            <form onSubmit={this.handleSubmit} id="forms-RI-Cadastro">
                <h1 id="tittle-forms-cme">Formulário para Receita</h1>
                <br></br>
                <p id="RI-Title-Cadastro" >Receita Médica</p>
                <input onChange={this.handleChange} name="prescription" placeholder="Insira sua receita: " id="RI-Cadastro" />
                <button onClick={() => this.handleSubmit} id="RI-Cadastro">Enviar</button>
            </form>
        );
    }
}
